"use strict";

angular.module("vendor")
.constant("CATALOG_HEADER_OFFSET", -300)
.constant("APPROVAL_GROUP_STRATEGY", {
    "MANUAL": "manual",
    "SEMI_AUTOMATIC": "semi_automatic",
    "AUTOMATIC": "automatic"
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog.constants.js
// module id = 863
// module chunks = 0